import axios from "axios";
import { deleteDoc, doc, addDoc, collection, getDoc } from "firebase/firestore";
import db from "../../config/firebase";

// initialState
const initialState = {
  clientId: 0,
  userId: 0,
  levelId: 0,
  roomId: 0,
  categoryId: 0,
  reservationId: 0,
  status: "ERROR",
  userStatus: "ERROR",
  levelStatus: "ERROR",
  roomStatus: "ERROR",
  categoryStatus: "ERROR",
  reservationStatus: "ERROR",
};

// types
const DELETE_CLIENT = "DELETE_CLIENT",
  DELETE_USER = "DELETE_USER",
  DELETE_LEVEL = "DELETE_LEVEL",
  DELETE_ROOM = "DELETE_ROOM",
  DELETE_CATEGORY = "DELETE_CATEGORY",
  DELETE_RESERVATION = "DELETE_RESERVATION",
  SAVE_ID = "SAVE_ID",
  SAVE_USER_ID = "SAVE_USER_ID",
  SAVE_LEVEL_ID = "SAVE_LEVEL_ID",
  SAVE_ROOM_ID = "SAVE_ROOM_ID",
  SAVE_CATEGORY_ID = "SAVE_CATEGORY_ID",
  SAVE_RESERVATION_ID = "SAVE_RESERVATION_ID";

// reducer
const deleteReducer = (state = initialState, action) => {
  switch (action.type) {
    case "DELETE_CLIENT":
      return {
        clientId: action.payload.id,
        status: action.payload.status,
      };
    case "DELETE_USER":
      return {
        userId: action.payload.id,
        userStatus: action.payload.status,
      };
    case "DELETE_LEVEL":
      return {
        levelId: action.payload.id,
        levelStatus: action.payload.status,
      };
    case "DELETE_ROOM":
      return {
        roomId: action.payload.id,
        roomStatus: action.payload.status,
      };
    case "DELETE_CATEGORY":
      return {
        categoryId: action.payload.id,
        categoryStatus: action.payload.status,
      };
    case "DELETE_RESERVATION":
      return {
        reservationId: action.payload.id,
        reservationStatus: action.payload.status,
      };
    case "SAVE_ID":
      return {
        ...state,
        clientId: action.payload,
      };
    case "SAVE_USER_ID":
      return {
        ...state,
        userId: action.payload.id,
        userStatus: action.payload.status,
      };
    case "SAVE_LEVEL_ID":
      return {
        ...state,
        levelId: action.payload.id,
        levelStatus: action.payload.status,
      };
    case "SAVE_ROOM_ID":
      return {
        ...state,
        roomId: action.payload.id,
        roomStatus: action.payload.status,
      };
    case "SAVE_CATEGORY_ID":
      return {
        ...state,
        categoryId: action.payload.id,
        categoryStatus: action.payload.status,
      };
    case "SAVE_RESERVATION_ID":
      return {
        ...state,
        reservationId: action.payload.id,
        reservationStatus: action.payload.status,
      };
    default:
      return state;
  }
};

// action
const saveIdAction = (id) => async (dispatch, getState) => {
  dispatch({
    type: DELETE_CLIENT,
    payload: { id: id, status: "ERROR" },
  });
};

const saveUserIdAction = (id) => async (dispatch, getState) => {
  dispatch({
    type: SAVE_USER_ID,
    payload: { id: id, status: "ERROR" },
  });
};

const saveLevelIdAction = (id) => async (dispatch, getState) => {
  dispatch({
    type: SAVE_LEVEL_ID,
    payload: { id: id, status: "ERROR" },
  });
};

const saveRoomIdAction = (id) => async (dispatch, getState) => {
  dispatch({
    type: SAVE_ROOM_ID,
    payload: { id: id, status: "ERROR" },
  });
};

const saveCategoryIdAction = (id) => async (dispatch, getState) => {
  dispatch({
    type: SAVE_CATEGORY_ID,
    payload: { id: id, status: "ERROR" },
  });
};

const saveReservationIdAction = (id) => async (dispatch, getState) => {
  dispatch({
    type: SAVE_RESERVATION_ID,
    payload: { id: id, status: "ERROR" },
  });
};

const deleteClientAction = () => async (dispatch, getState) => {
  let newClient = new FormData(),
    id = getState().Delete.clientId;

  //newClient.append('METHOD', 'DELETE');
  try {
    await deleteDoc(doc(db, "client", `${id}`));
    // adding to state
    dispatch({
      type: DELETE_CLIENT,
      payload: { id: id, status: "SUCCESS" },
    });
  } catch (error) {
    console.log(error);
  }
};

const deleteUserAction = () => async (dispatch, getState) => {
  let newUser = new FormData(),
    id = getState().Delete.userId;

  try {
    await deleteDoc(doc(db, "user", `${id}`));
    // adding to state
    dispatch({
      type: DELETE_USER,
      payload: { id: id, status: "SUCCESS" },
    });
  } catch (error) {
    console.log(error);
  }
};

const deleteLevelAction = () => async (dispatch, getState) => {
  let newLevel = new FormData(),
    id = getState().Delete.levelId;

  try {
    await deleteDoc(doc(db, "level", `${id}`));
    // adding to state
    dispatch({
      type: DELETE_LEVEL,
      payload: { id: id, status: "SUCCESS" },
    });
  } catch (error) {
    console.log(error);
  }
};

const deleteRoomAction = () => async (dispatch, getState) => {
  let roomLevel = new FormData(),
    id = getState().Delete.roomId;

  try {
    await deleteDoc(doc(db, "room", `${id}`));
    // adding to state
    dispatch({
      type: DELETE_ROOM,
      payload: { id: id, status: "SUCCESS" },
    });
  } catch (error) {
    console.log(error);
  }
};

const deleteCategoryAction = () => async (dispatch, getState) => {
  let categoryToDelete = new FormData(),
    id = getState().Delete.categoryId;

  try {
    await deleteDoc(doc(db, "category", `${id}`));
    // adding to state
    dispatch({
      type: DELETE_CATEGORY,
      payload: { id: id, status: "SUCCESS" },
    });
  } catch (error) {
    console.log(error);
  }
};

const deleteReservationAction = () => async (dispatch, getState) => {
  let reservationToDelete = new FormData(),
    id = getState().Delete.reservationId;

  try {
    const docRef = doc(db, "reservation", `${id}`);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      let data = docSnap.data();

      // save reservation in other table
      const docRef = await addDoc(collection(db, "cancelledReservation"), data);

      // delete reservation
      await deleteDoc(doc(db, "reservation", `${id}`));
      dispatch({
        type: DELETE_RESERVATION,
        payload: { id: id, status: "SUCCESS" },
      });
    } else {
      console.log("error");
    }
  } catch (err) {
    console.log(err);
  }
};

// export
export {
  deleteClientAction,
  saveIdAction,
  saveUserIdAction,
  saveLevelIdAction,
  saveRoomIdAction,
  saveCategoryIdAction,
  saveReservationIdAction,
  deleteUserAction,
  deleteLevelAction,
  deleteRoomAction,
  deleteCategoryAction,
  deleteReservationAction,
};

export default deleteReducer;
